import React from "react"
import classNames from "classnames"
import dayjs from "dayjs"

import "./News.sass"

export default function News({ article, truncated }) {
	const newsClassName = classNames({
		News: true,
		playback: true,
	})

	const remaining = article.description.substring(
		truncated.length,
		article.description.length,
	)

	const dateFormat = dayjs(article.publishedAt).format("ddd D MMM YYYY, HH:MM")

	return (
		<div className={newsClassName}>
			<h1>{article.title}</h1>
			<p className="description">
				<span className="truncated">{truncated}</span>
				<span className="remaining">{remaining}</span>
			</p>
			<p className="url">
				<a href={article.url} target="_blank" rel="noopener noreferrer">
					{article.url}
				</a>
			</p>
			<p className="url">{dateFormat}</p>
		</div>
	)
}
